import _ from 'lodash'
import { searchConfig } from '@pt/api/assets/index.type'

export const queryConfig: searchConfig = {
  keyword: '',
  search_field: 'name',
  utime_e: '',
  utime_s: '',
  ctime_e: '',
  ctime_s: '',
  bitrate_max: 0,
  bitrate_min: 0,
  height_max: 0,
  height_min: 0,
  width_max: 0,
  width_min: 0,
  ratios: [],
  directions: [],
  sizes: [],
  formats: [],
  types: [],
  source: [],
  page_size: 50,
  page: 1,
  order: '-updated_time',
  created_time: [],
  updated_time: [],
  size_max: 0,
  size_min: 0,
  size_unit: 'KB',
  duration_min: 0,
  duration_max: 0,
  duration_unit: 'sec',
}

export const filterChange = (
  data: { prop: string; value: any }[] | { prop: string; value: any },
  query: searchConfig,
) => {
  const temp = _.cloneDeep(query)
  // 传过来的 min/max 是否含有小数点，如果含有，不更新路由
  let hasFloatNum = false
  if (_.isArray(data)) {
    data.forEach((item) => {
      // @ts-ignore
      temp[item.prop] = item.value
      if (
        (item.prop.includes('min') || item.prop.includes('max')) &&
        !_.isInteger(item.value)
      ) {
        hasFloatNum = true
      }
    })
  } else {
    // @ts-ignore
    temp[data.prop] = data.value
    if (
      (data.prop.includes('min') || data.prop.includes('max')) &&
      !_.isInteger(data.value)
    ) {
      hasFloatNum = true
    }
  }
  if (!hasFloatNum) {
    temp.page = 1
  }

  return temp
}

export const transformQuery = (query: searchConfig): searchConfig => {
  const temp = _.cloneDeep(query)
  if (temp.created_time && temp.created_time.length) {
    temp.ctime_s = temp.created_time[0]!
    temp.ctime_e = temp.created_time[1]!
  }
  if (temp.updated_time && temp.updated_time.length) {
    temp.utime_s = temp.updated_time[0]!
    temp.utime_e = temp.updated_time[1]!
  }
  if (temp.size_min || temp.size_max) {
    if (temp.size_unit === 'KB') {
      temp.size_min =
        temp.size_min !== undefined
          ? Math.round(temp.size_min * 1024)
          : temp.size_min
      temp.size_max =
        temp.size_max !== undefined
          ? Math.round(temp.size_max * 1024)
          : temp.size_max
    }
    if (temp.size_unit === 'MB') {
      temp.size_min =
        temp.size_min !== undefined
          ? Math.round(temp.size_min * 1024 * 1024)
          : temp.size_min
      temp.size_max =
        temp.size_max !== undefined
          ? Math.round(temp.size_max * 1024 * 1024)
          : temp.size_max
    }
  }
  delete temp.size_unit
  delete temp.created_time
  delete temp.updated_time
  delete temp.menu_type
  delete temp.filter_visible
  return temp
}
